// extracted by mini-css-extract-plugin
export default {"cls1":"MiYBj90ru4sYyF0ZsmFA","cls2":"YNnIWJCCB26zm12AJ3Tt MiYBj90ru4sYyF0ZsmFA"};